<template>
	<div id='usuario-editar'>
		<h2>EDITAR USUARIO </h2>
        <a @click="$router.go(-1)">regresar</a>

		<br>
		<div id='usuario-ver' align="center">
		<form v-on:submit.prevent= 'guardarUsuario'>
			<table>
				<tr>
				  <td>Mail</td>
				  <td><input type='text' name='mail' v-model='usuarios.mail' disabled size="40px"  ></td>
				</tr>
				<tr>
				  <td>Nombre </td>
				  <td><input type='text' name='nombreCompleto' v-model='usuarios.nombreCompleto' disabled size="40px"></td>
				</tr>
				<tr>
				  <td>Su clave</td>
				  <td><input type='text' name='suClave' v-model='usuarios.suClave'  required ></td>
				</tr>
				<tr>
				  <td>Celular</td>
				  <td><input type='text' name='celular' v-model='usuarios.celular'  required></td>
				</tr>
				<tr>
				  <td>Whatsapp</td>
				  <td><input type='text' name='whatsapp' v-model='usuarios.whatsapp' required></td>
				</tr>
				<tr>
				  <td>Status</td>
				  <td>
				  		<select name="status" required v-model="usuarios.status">
								<option value="A">ALTA</option>
	  							<option value="B">BAJA</option>
	  							<option value="I">INACTIVO</option>

						</select>
					</td>
				</tr>

				<tr>
					<td>Permisos actuales: 
					</td>
					<td width="80px">{{cadenaSeleccion}}
					</td>
				</tr>
				<tr>
				   <td>Permisos a agregar:
				  </td>
				  <td>
						<select name="permisos" v-model="seleccion" v-on:change='agregaSeleccion(seleccion)'>
						<option disabled value="">Seleccione para agregar</option>
						<option>Propiedades Consulta</option>
						<option>Propiedades Altas</option>
						<option>Propiedades Ver detalle</option>
						<option>Propiedades Editar</option>

						<option>Inquilinos Consulta</option>
						<option>Inquilinos Altas</option>
						<option>Inquilinos Ver Detalle</option>				
						<option>Inquilinos Editar</option>

						<option>Movimientos Consulta</option>
						<option>Movimientos Altas</option>

						<option>Contratos Consulta</option>
						<option>Contratos Altas</option>
						<option>Contratos Ver detalle</option>
						<option>Contratos Editar</option>

						<option>Movimientos Altas</option>
						<option>Movimientos Consulta</option>

						<option>Cobros Consulta</option>				
						<option>Cobros Altas</option>

						<option>Reportes de Propiedades </option>
						<option>Reportes de Inquilinos</option>
						<option>Reportes de Movimientos</option>
						<option>Reportes de Contratos</option>

						<option>Usuarios Altas</option>
						<option>Usuarios Editar</option>

					</select>
				</td>

				</tr>

				<tr>
				  <td>Permisos a quitar:</td>
				  <td>
					<select name="permiq" v-model="seleccionQ" v-on:change='quitarSeleccion(seleccionQ)'>
						<option disabled value="">Seleccione para quitar</option>
						<option>Propiedades Consulta</option>
						<option>Propiedades Altas</option>
						<option>Propiedades Ver detalle</option>
						<option>Propiedades Editar</option>

						<option>Inquilinos Consulta</option>
						<option>Inquilinos Altas</option>
						<option>Inquilinos Ver Detalle</option>				
						<option>Inquilinos Editar</option>

						<option>Movimientos Consulta</option>
						<option>Movimientos Altas</option>

						<option>Contratos Consulta</option>
						<option>Contratos Altas</option>
						<option>Contratos Ver detalle</option>
						<option>Contratos Editar</option>

						<option>Movimientos Altas</option>
						<option>Movimientos Consulta</option>

						<option>Cobros Consulta</option>				
						<option>Cobros Altas</option>

						<option>Reportes de Propiedades </option>
						<option>Reportes de Inquilinos</option>
						<option>Reportes de Movimientos</option>
						<option>Reportes de Contratos</option>

						<option>Usuarios Altas</option>
						<option>Usuarios Editar</option>

					</select>
				</td>

				</tr>
			</table>

			<br>
			<input type="submit" name="agregandoUsuario">
		</form>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default{
			name:'editar-usuario',
			mounted(){
				this.entrar();
			},
			props:['vector'],
			data(){
				return {
					id: null,
					usuarios:{
						mail:'',
						nombreCompleto:'',
						suClave:'',
						celular:'',
						whatsapp:'',
						status:'',
						fechaModifica:'',
						quienModifico:'',
						permisos:'',
					},
					seleccion:'',
					seleccionQ:'',
					cadenaSeleccion:''
				};
			},
			methods:{
				entrar(){
				// checa si tiene autorizacion
		  		if(!this.vector.includes('MASTERGGUV')){
			  		if(!this.vector.includes('Usuarios Editar')){
			  			document.getElementById('usuario-ver').hidden = true;
			  			alert('Seccion no autorizada');
			  			return;
			  		}
			  	}
				var pro= ''; 
				var usuarios2= '';

				this.id=this.$route.params.idparam;
				axios.get('https://www.directodo.com/Rentus/accesosdb/leeUnUsuario.php?idu='+this.id)
  		             .then((respue) => {
  		     			pro = respue.data;

   						usuarios2 = pro[0];// lee el unico registro cero

						this.usuarios.idu = this.id;
						this.usuarios.mail = usuarios2.mail;
						this.usuarios.nombreCompleto = usuarios2.nombreCompleto;
						this.usuarios.suClave = usuarios2.suClave;
						this.usuarios.celular = usuarios2.celular;
						this.usuarios.whatsapp = usuarios2.whatsapp;
						this.usuarios.status = usuarios2.status;
						this.usuarios.fechaModifica = usuarios2.fechaModifica;
						this.usuarios.quienModifico = usuarios2.quienModifico;
						this.cadenaSeleccion = usuarios2.permisos;

  			 		 });
				},
				guardarUsuario(){
					var propiedades2 = this.usuarios;
					var router= this.$router;

					axios.post('https://www.directodo.com/Rentus/accesosdb/modificaUsuario.php?idu='+this.usuarios.idu +'&suClave='+this.usuarios.suClave+'&celular='+this.usuarios.celular+'&whatsapp='+this.usuarios.whatsapp+'&status='+this.usuarios.status+'&fechaModifica='+this.fechaActual()+'&quienModifico='+this.usuarios.quienModifico+'&permisos='+this.cadenaSeleccion)
		  		          .then((respue) => {
		  		          		if (respue.statusText == 'OK'){
		  		          			router.push('/usu')
		  		          		}
		  			 	  })
		  		          .catch((error) =>{
		  		          		console.log(error);
		  		          });
				},

				agregaSeleccion(selec){
					if(!this.cadenaSeleccion.includes(selec)){
						this.cadenaSeleccion +='-' + selec +'\n';
					}
				},
				quitarSeleccion(selec){
						this.cadenaSeleccion =  this.cadenaSeleccion.replace('-'+selec,'');
				},

				fechaActual(){      
				    var currentDate = new Date() //hoy
				    var day = currentDate.getDate();
				    var month = currentDate.getMonth() + 1;
				    var year = currentDate.getFullYear();
				    var my_date = year+"-"+month+"-"+day;
				    return my_date;    
				}
			}
	}
</script>


// WEBPACK FOOTER //
// src/Usuario-editar.vue